export default "__VITE_ASSET__Ctd4wciY__"